"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Variant = void 0;
var Variant = exports.Variant = /*#__PURE__*/function (Variant) {
  Variant["DEFAULT"] = "default";
  Variant["DESTRUCTIVE"] = "destructive";
  Variant["DEFAULT_INVERSE"] = "defaultInverse";
  Variant["SPECIAL"] = "special";
  Variant["QUIET"] = "quiet";
  Variant["QUIET_DESTRUCTIVE"] = "quietDestructive";
  Variant["QUIET_INVERSE"] = "quietInverse";
  Variant["PADDINGLESS"] = "paddingless";
  Variant["PADDINGLESS_DESTRUCTIVE"] = "paddinglessDestructive";
  Variant["DESTRUCTIVE_PADDINGLESS"] = "destructivePaddingless";
  Variant["PADDINGLESS_INVERSE"] = "paddinglessInverse";
  return Variant;
}(Variant || {});